export const THIS_MONTH_FILTER_KEY = 'this_month';
export const LAST_MONTH_FILTER_KEY = 'last_month';
export const LAST_7_DAYS_FILTER_KEY = 'last_7_days';
export const TODAY_FILTER_KEY = 'today';
export const YESTERDAY_FILTER_KEY = 'yesterday';
export const CUSTOMIZED_FILTER_KEY = 'customize';
export const LAST_30_DAYS_FILTER_KEY = 'last_30_days';

export const COMPARE_LOGIC = {
	lastMonth: 'last_month',
	last7Days: 'last_7_days',
	today: 'today',
	yesterday: 'yesterday',
	custom: 'custom',
	thisMonth: 'this_month',
	last30Days: 'last_30_days',
};

export const DATEFILTERS = {
	CUSTOMIZED_FILTER_KEY: {
		label: CUSTOMIZED_FILTER_KEY,
		value: CUSTOMIZED_FILTER_KEY,
		dateLogic: COMPARE_LOGIC.custom,
	},
	THIS_MONTH_FILTER_KEY: {
		label: THIS_MONTH_FILTER_KEY,
		value: THIS_MONTH_FILTER_KEY,
		dateLogic: COMPARE_LOGIC.thisMonth,
	},
	LAST_MONTH_FILTER_KEY: {
		label: LAST_MONTH_FILTER_KEY,
		value: LAST_MONTH_FILTER_KEY,
		dateLogic: COMPARE_LOGIC.lastMonth,
	},
	LAST_30_DAYS_FILTER_KEY: {
		label: LAST_30_DAYS_FILTER_KEY,
		value: LAST_30_DAYS_FILTER_KEY,
		dateLogic: COMPARE_LOGIC.last30Days,
	},
	LAST_7_DAYS_FILTER_KEY: {
		label: LAST_7_DAYS_FILTER_KEY,
		value: LAST_7_DAYS_FILTER_KEY,
		dateLogic: COMPARE_LOGIC.last7Days,
	},
	TODAY_FILTER_KEY: {
		label: TODAY_FILTER_KEY,
		value: TODAY_FILTER_KEY,
		dateLogic: COMPARE_LOGIC.today,
	},
	YESTERDAY_FILTER_KEY: {
		label: YESTERDAY_FILTER_KEY,
		value: YESTERDAY_FILTER_KEY,
		dateLogic: COMPARE_LOGIC.yesterday,
	},
};
